// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../../ContactBand";

export default function CaseAssetSim() {
  return (
    <main>
      <section className="page-hero ground cd-hero" data-en="WORKS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/cases">実績・事例</Link>
            <span>資産運用シミュレーション</span>
          </nav>
          <div className="case-tags cd-tags">
            <span>金融・資産運用</span>
            <span>Webシステム開発</span>
          </div>
          <h1 className="cd-title">
            資産運用のシミュレーションから、アドバイザーとの面談につなげるリード獲得システム
          </h1>
          <p className="cd-client">金融サービス会社</p>
          <div className="cd-img is-cover">
            <span className="cover-en">LEAD GENERATION</span>
            <span className="cover-ja">資産運用 × Webシステム</span>
          </div>
          <div className="cd-summary">
            <div>
              <span>課題</span>
              <p>
                資産運用に関心のある見込み客を集め、面談までつなげる仕組みが必要だった。
              </p>
            </div>
            <div>
              <span>解決策</span>
              <p>
                シミュレーションLP・SMS認証・管理画面・面談管理を一体で開発。
              </p>
            </div>
            <div>
              <span>成果</span>
              <p>
                見込み客の獲得から面談の成立までを、1つのシステムで管理できる形に。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="cd-body container">
          <section className="cd-sec">
            <h2>プロジェクト概要</h2>
            <p>
              資産運用に関心のあるユーザーが、年齢・性別・職業などを入力してシミュレーションを行い、その情報をもとにアドバイザーとの面談につなげるリード獲得システムを開発しました。ユーザー向けのLP、サービス運営者向けの管理画面、面談を担当する事業者向けのダッシュボードまでを一貫して手がけています。
            </p>
          </section>
          <section className="cd-sec">
            <h2>お客様の課題</h2>
            <ul className="cd-list">
              <li>
                資産運用に関心のある見込み客を、Webから効率よく集めたかった
              </li>
              <li>
                いたずらや重複の登録を防ぎ、確度の高いリードだけを残したかった
              </li>
              <li>
                集まったリードを案件として管理し、面談の成立まで追える仕組みが必要だった
              </li>
            </ul>
          </section>
          <section className="cd-sec">
            <h2>LEAPSの対応</h2>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">ユーザー向けLP</p>
                <h3 className="cd-ptitle">入力からSMS認証までの体験設計</h3>
                <p>
                  基本情報・連絡先の入力、確認、SMSによる本人確認、完了までの流れを設計・実装。同じ電話番号での重複登録も防ぎます。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">管理画面</p>
                <h3 className="cd-ptitle">案件と面談実績の管理</h3>
                <p>
                  LPから届いたリードを案件として一覧・検索し、面談の実績を集計できる運営者向けの管理画面を開発しました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">事業者向けダッシュボード</p>
                <h3 className="cd-ptitle">面談希望から成立まで</h3>
                <p>
                  事業者が案件の詳細を確認して面談を希望し、成立したときにだけ連絡先が開示される仕組みを実装しました。
                </p>
              </div>
            </div>
          </section>
          <section className="cd-sec">
            <h2>技術・体制</h2>
            <p>
              React、AWS
              Lambda、PostgreSQL、SMS認証（Twilio）で構成。要件定義から設計・開発・テスト・リリース、リリース後の保守運用までを担当しました。
            </p>
          </section>
        </div>
      </section>
      <section className="section ground">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            ほかの事例<strong>Other Works</strong>
          </h2>
          <div className="case-grid">
            <Link className="case-card" to="/cases/anybound">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」
              </h3>
              <div className="case-tags">
                <span>エンタープライズ</span>
                <span>ブロックチェーン事業開発</span>
                <span>共創プロジェクト</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/kanda-curry">
              <div className="case-img is-cover">
                <span className="cover-en">NFT STAMP RALLY</span>
                <span className="cover-ja">スタンプラリー × NFT</span>
              </div>
              <p className="case-meta">広告代理店</p>
              <h3>
                スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
              </h3>
              <div className="case-tags">
                <span>イベント・観光</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/premience">
              <div className="case-img">
                <img src="/assets/images/case-premience.jpg" alt="" />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                JTBのラグジュアリー体験ブランド「プレミエンス」のロゴ制作とサイトリニューアル
              </h3>
              <div className="case-tags">
                <span>旅行・観光</span>
                <span>ブランディング・Web制作</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <ContactBand ground={false} />
    </main>
  );
}
